let appVersion: string;

try {
  appVersion = require("../../package.json").version;
} catch (error) {
  console.error("Error: package.json not found. Falling back to default version.");
  appVersion = "0.0.0"; // Provide a default value or handle it as needed
}
const hostname = window?.location?.hostname;
// Detect environment
const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
const production = !isLocal;
// Real Turnstile site key (including localhost) so CF can verify with production secret
const siteKey = '0x4AAAAAABmd0ZiMZfWpJxlX';
export const environment = {
  firebase: {
    apiKey: "AIzaSyCDLD7VPidFJYUshUYGROxUQvG6Y2mvNuU",
    authDomain: "lottosocial-9f7a2.firebaseapp.com",
    projectId: "lottosocial-9f7a2",
    storageBucket: "lottosocial-9f7a2.appspot.com",
    appId: "1:1032853906992:web:a586b870046294e395eff5",
    measurementId: "G-6C2HKJP8NP",
    databaseURL: "https://lottosocial-9f7a2.firebaseio.com",
  },
  clarity: {
    projectId: "wcne4x6rr4",
  },
  turnstile: {
    siteKey,
    enabled: true
  },
  mirrorPath: 'public_',
  emulateFirebase: false,
  production: true,
  showDevelopmentPremiumGames: false,
  swSchemaVersion: appVersion,
  chatbotApiKey: 'MdBCcuLbQ_Z_VRVUZHdwBxqU9XfUmOWE',
  appVersion: appVersion,
  recaptcha: {
    siteKey: '6LdUZAIgAAAAADZ1X7TC9RcNMEodH1jg8hiQ2ifB'
  },
  checkOutUrl: "https://api.sandbox.checkout.com/sessions-interceptor/sid_w35fdpyurafuhbueovbc3olbqa",
  postCacheTypedFormsURL: "https://form.typeform.com/to/mLc8Jpz7",
  clevertapAccountId: "97Z-R4W-955Z",
  // HATDEV-1M17: Disable CleverTap in-app messaging to prevent infinite recursion crash on iOS
  clevertapEnableInApps: false
};
